import { useState } from "react";
import { useQuery } from "@tanstack/react-query";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import { Card } from "@/components/ui/card";
import { Input } from "@/components/ui/input";
import { Buildings, Users, Storefront, ArrowsClockwise, MagnifyingGlass, ArrowRight } from "@phosphor-icons/react";

export default function OrgDirectory() {
  const [q, setQ] = useState("");
  const { data: orgs = [], isLoading } = useQuery({ queryKey: ["org-directory"], queryFn: async () => (await api.get("/organizations-directory")).data });
  const filtered = orgs.filter((o) => o.name.toLowerCase().includes(q.toLowerCase()));

  return (
    <div className="animate-fade-up" data-testid="org-directory-page">
      <div className="flex items-center gap-2 mb-1"><Buildings className="h-5 w-5 text-primary" weight="bold" /><p className="overline text-primary">Directory</p></div>
      <h1 className="text-3xl font-black tracking-tight">Organizations</h1>
      <p className="text-muted-foreground text-sm mt-1 mb-6">Explore workplaces on MyPayAlert and their live shift activity.</p>

      <div className="relative max-w-md mb-6">
        <MagnifyingGlass className="h-4 w-4 absolute left-3 top-1/2 -translate-y-1/2 text-muted-foreground" weight="bold" />
        <Input data-testid="org-directory-search" className="pl-9 bg-secondary/50" placeholder="Search organizations…" value={q} onChange={(e) => setQ(e.target.value)} />
      </div>

      {isLoading ? <p className="text-muted-foreground text-sm">Loading…</p> : (
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-4" data-testid="org-directory-grid">
          {filtered.map((o) => (
            <Link key={o.id} to={`/organizations/${o.id}`} data-testid={`org-dir-${o.id}`}
              className="group block">
              <Card className="p-5 bg-card border-border h-full transition-colors duration-200 group-hover:border-primary/50">
                <div className="flex items-start justify-between">
                  <div className="flex items-center gap-2">
                    <div className="h-10 w-10 rounded-lg bg-primary/10 flex items-center justify-center"><Buildings className="h-5 w-5 text-primary" weight="bold" /></div>
                    <div>
                      <p className="font-bold leading-tight">{o.name}</p>
                      <p className="text-xs text-muted-foreground">{o.type}</p>
                    </div>
                  </div>
                  <ArrowRight className="h-4 w-4 text-muted-foreground opacity-0 group-hover:opacity-100 transition-opacity duration-200" />
                </div>
                <div className="flex items-center gap-4 mt-4 text-sm text-muted-foreground">
                  <span className="flex items-center gap-1.5"><Users className="h-4 w-4" weight="bold" /> {o.members}</span>
                  <span className="flex items-center gap-1.5"><Storefront className="h-4 w-4" weight="bold" /> {o.open_shifts}</span>
                  <span className="flex items-center gap-1.5"><ArrowsClockwise className="h-4 w-4" weight="bold" /> {o.open_swaps}</span>
                </div>
              </Card>
            </Link>
          ))}
        </div>
      )}
    </div>
  );
}
